<template>
    <div v-html="data.html"></div>
</template>

<script>
    export default {
        name: 'html-string',
        props: ['data'],
    }
</script>



// WEBPACK FOOTER //
// HtmlString.vue?75a22ace